// Styles
import styles from './Logo.module.css';

/**
 * @function Logo
 * Bingoport logo
 *
 * @example
 * return (
 *   <Logo type="full" />
 * )
 */
function Logo({ type = 'full' }: LogoProps): JSX.Element {
    const filename = type === 'full' ? 'logo-white' : 'logo-circle-white';

    return (
        <picture className={styles.picture}>
            <a
                href="https://www.bingoport.com/"
                target="_blank"
                rel="noreferrer"
            >
                <img
                    src={`https://${process.env.REACT_APP_CDN}/play-bingo/images/logos/${filename}.svg`}
                    alt="logo"
                />
            </a>
        </picture>
    );
}

/**
 * @interface LogoProps
 * Describes the properties required for the Lead component
 *
 * @property {string} type
 */
export interface LogoProps {
    type: 'full' | 'circle';
}

// Exports
export default Logo;
